import { object, array, string, setLocale } from 'yup';
import {  send } from '../../../fix-search/API';

export const rulesValidation = {}

var currTransactionId = 0

const sendRoutingRuleValidationRequest = (rule, token, onSuccess, onError) => {
  // console.log("Sending routing rule validation request", rule)
  const transactionId = currTransactionId++
  send('validateRoutingRule', {
    '@RoutingRuleValidationRequest': {
      transactionId: transactionId,
      sessionId: token,
      ruleId: rule.id,
      routingRule: {
        '@RoutingRule': {
          ...rule,
          id: undefined
        }
      }
    }
  })
  .then(onSuccess)
  .catch(onError)

  return transactionId;
}

const composeYupResult = (result, testContext) => {
  return result.correct 
    ? result.correct
    : testContext.createError({ message: result.errorMessage });
}

const validatePattern = (rule, index, token, testContext) => {
  const id = rule.id
  const pattern = rule.pattern
  
  var validation = rulesValidation[id]
  if (!validation) {
    validation = { previous: {} }
    rulesValidation[id] = validation
  }

  // console.log('Validation for rule', index, ' is triggered!')

  // Validation for this pattern is already in progress
  if (validation.inProgress && validation.pattern === pattern) {
    // console.log('Validation for rule', index, 'pattern is already in progress!')
    return validation.promise
  }
  
  // This pattern was validated previously
  if (validation.previous.pattern === pattern) {
    // console.log('Pattern for rule', index, '[', id, '] is already validated, returning previous result', validation.previous)

    // Validation for an older value is in progress, discard it
    if (validation.inProgress) {
      validation.inProgress = undefined
      validation.pattern = pattern
    }

    return composeYupResult(validation.previous.result, testContext)
  }

  // Check for obvious errors
  if (pattern === 'false' || !pattern) {
    // console.log('Pattern for rule', index, ' is incorrect!')

    validation.previous.pattern = pattern
    validation.previous.result = false

    return composeYupResult(validation.previous.result, testContext)
  }

  // console.log('Starting long validation of rule pattern', pattern, 'index', index, 'id', id)

  validation.inProgress = true
  validation.pattern = pattern
  
  validation.promise = 
    new Promise(
      (resolve, reject) => {
        validation.resolve = resolve
        validation.reject = reject
      }
    )
    .then(
      (result) => {
        console.log('Long validation result for', result)

        if (validation.pattern === pattern) {
          validation.inProgress = undefined
          validation.previous.pattern = pattern
          validation.previous.result = result;
        } else {
          // console.log(
          //   'Pattern has already changed, ignoring this result.', '\n',
          //   'Expected:\'',  pattern, '\'\n',
          //   'Actual:\'', validation.pattern, '\'')
        }

        // console.log(validation.previous.result)
        
        return composeYupResult(validation.previous.result, testContext)
      },
      (error) => {
        console.log('Failed to validate routing rules', error)
      })

  validation.transactionId = sendRoutingRuleValidationRequest(
    rule,
    token,
    (result) => {
      // console.log('Routing rule validation request send successfully', result)
    },
    (error) => {
      console.log('Failed to send routing rules validation request', error)
    }
  )

  return validation.promise
}

// Change "required" field error
setLocale({
  mixed: {
    required: "Required"
  }
});

export const routingRulesSchema = (token) =>
  object()
    .shape({
      rules: array().of(
        object().shape({
          pattern: string()
            .required()
            .label("Pattern")
            .test(
              'is-pattern-correct',
              "Incorrect pattern",
              (pattern, testContext) => {
                const index = testContext.options.index;
                return validatePattern(testContext.parent, index, token, testContext)
              }
            )
            ,
          policy: string().nullable(true).required(),
          routes: array().of( string() ).min(1, "At least one route required").required()
        })
      )
      .required()
    })
    .required()
